import React, { Component } from 'react';
import Slider from '../../../../Part_Sample/Slider';
import { isEmpty } from '../../../../Common/Common';

export default class Operation_Slider extends Component {
	constructor(props) {
		super(props);

		let sp = 16;

		if (this.props.group_id == null) {
			if (!isEmpty(this.props.point_info)) {
				if(this.props.point_info.type == 'Dehumi') {
					sp = this.props.point_info.hum_sp;
				} else {
				if (this.props.point_info.actual_mode == 'H') {
					sp = this.props.point_info.hsp;
				} else if (this.props.point_info.actual_mode == 'C') {
					sp = this.props.point_info.csp;
				}
			}
		}
		}

		this.state = {
			sp: sp,
			mode: this.props.mode,
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.mode != nextState.mode) {
			let sp = this.state.sp;

			if (this.props.group_id == null) {
				if (nextProps.mode == 'H') {
					sp = this.props.point_info.hsp;
				}
				else if (nextProps.mode == 'C') {
					sp = this.props.point_info.csp;
				}
				else {
					if(this.props.point_info.type == 'Dehumi') {
						sp = this.props.point_info.hum_sp;
					} else {
					if (this.props.point_info.actual_mode == 'H') sp = this.props.point_info.hsp;
					else if (this.props.point_info.actual_mode == 'C') sp = this.props.point_info.csp;
				}
			}
			}

			this.setState({
				mode: nextProps.mode,
				sp: sp
			})
		}
		return true;
	}

	handleChangeSP = (val) => {
		val = parseFloat(val)
		this.setState({ sp: val })
		this.props.handleChangeVal(val);
	}

	render() {
		let min = 16;
		let max = 32;
		let step = 0.1;
		let font_colour = window.app.state.colours.csp_font_colour;

		let sliderValue = this.props.receiver.getString('temp');
		let sliderUnit = this.props.receiver.getString('DEG');

		if (this.props.group_id == null) {
			if (!isEmpty(this.props.point_info)) {
				if(this.props.point_info.type == 'Dehumi') {
					min = this.props.point_info.hum_range[0];
					max = this.props.point_info.hum_range[1];
					step = this.props.point_info.sp_step;
					sliderValue = this.props.receiver.getString('humi');
					sliderUnit = this.props.point_info.unit;
				} else {
				min = this.props.point_info.csp_range[0];
				max = this.props.point_info.csp_range[1];
				step = this.props.point_info.sp_step;

				if (this.props.mode == 'H' || (this.props.mode == 'T' && this.props.point_info.actual_mode == 'H')) {
					min = this.props.point_info.hsp_range[0];
					max = this.props.point_info.hsp_range[1];
					font_colour = window.app.state.colours.hsp_font_colour;
				}
			}
			}
		} else {
			if (this.props.mode == 'H') font_colour = window.app.state.colours.hsp_font_colour;
		}

		if (step < 0.5) step = 0.5;

		return (
			<div id='slider' style={{ cursor: 'pointer', textAlign: 'left' }}>
				<div style={{ color: font_colour, marginTop: 20, marginBottom: 20 }}>
					<div style={{ display: 'inline-block', marginLeft: 20, width: (this.props.width - 40) / 2 }}>
						<span >{sliderValue}</span>
					</div>
					<div style={{ display: 'inline-block', marginRight: 20, width: (this.props.width - 40) / 2, textAlign: 'right' }}>
						<span>{this.state.sp}{sliderUnit}</span>
					</div>
				</div>
				<div style={{ width: this.props.width - 100, marginLeft: 'auto', marginRight: 'auto' }}>
					<Slider
						style={{ width: '100%', display: 'inline-block', maxWidth: 'unset' }}
						value={this.state.sp}
						min={min}
						max={max}
						step={step}
						handleChangeSliderVal={this.handleChangeSP} />
				</div>
				<div style={{ width: this.props.width - 60, marginLeft: 'auto', marginRight: 'auto', marginTop: 10 }}>
					<div style={{ width: '50%', textAlign: 'left', display: 'inline-block', }}>
						<span>{min}</span>
					</div>
					<div style={{ width: '50%', textAlign: 'right', display: 'inline-block', }}>
						<span>{max}</span>
					</div>
				</div>
			</div>
		)
	}
}